import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';
import ProgressActivity from '~icons/material-symbols/progress-activity';

function Spinner({ className }: { className?: string }) {
  const { t } = useTranslation();

  return (
    <ProgressActivity
      role="status"
      aria-hidden={false}
      aria-label={t($ => $.loading)}
      className={cn('size-4 animate-spin', className)}
    />
  );
}

export { Spinner };
